export function fallbackString(value, defaultValue) {
  return value?.trim() ? value : defaultValue;
}